var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUiDownloadLtr = function SvgUiDownloadLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m51.033 74.416 18.312-18.114a2.21 2.21 0 0 0 .036-3.102 2.16 2.16 0 0 0-3.073-.037L51.67 67.658V12.19A2.18 2.18 0 0 0 49.5 10a2.18 2.18 0 0 0-2.17 2.19v55.468L32.692 53.163a2.16 2.16 0 0 0-3.073.037 2.21 2.21 0 0 0 .036 3.102l18.457 18.114c.193.192.425.342.68.438a2.16 2.16 0 0 0 1.561 0c.255-.096.486-.246.68-.438M86 88c0-1.105-.963-2-2.15-2H16.087c-1.158.032-2.087.915-2.087 2 0 1.105.963 2 2.15 2h67.763C85.07 89.967 86 89.084 86 88"
  })));
};
export default SvgUiDownloadLtr;